
export default function Contact() {
  return (
    <footer className="bg-gradient-to-br from-emerald-900 via-teal-900 to-emerald-950 text-white">
      <div className="px-8 lg:px-16 py-20">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
            <div className="space-y-4">
              <div className="flex items-center gap-3 mb-6">
                <img 
                  src="https://public.readdy.ai/ai/img_res/13a59a82-ac3f-4327-a38e-b3f3a099a49a.png" 
                  alt="FLAMA S.R.L. Logo" 
                  className="h-10 w-10 object-contain"
                />
                <span className="text-xl font-bold">FLAMA S.R.L.</span>
              </div>
              <p className="text-sm text-gray-300 leading-relaxed">
                Developing modern iOS applications that prioritize security, performance, and user experience. Your trusted partner in mobile innovation.
              </p>
            </div>
            
            <div className="space-y-4">
              <h3 className="text-xs uppercase tracking-wider text-gray-400 mb-6">
                Stay Connected
              </h3>
              <div className="flex items-center gap-2">
                <input
                  type="email"
                  placeholder="Enter your email"
                  className="flex-1 bg-transparent border-b border-gray-500 pb-2 text-sm text-white placeholder-gray-400 focus:outline-none focus:border-white transition-colors"
                />
                <button className="w-8 h-8 flex items-center justify-center bg-white/10 rounded-full hover:bg-white/20 transition-colors cursor-pointer">
                  <i className="ri-arrow-right-line text-white w-4 h-4 flex items-center justify-center"></i>
                </button>
              </div>
              <p className="text-xs text-gray-400">
                Subscribe to our newsletter
              </p>
            </div>
            
            <div className="space-y-4">
              <h3 className="text-xs uppercase tracking-wider text-gray-400 mb-6">
                Quick Links
              </h3>
              <div className="space-y-3">
                {['Home', 'About', 'Products'].map((link) => (
                  <button
                    key={link}
                    onClick={() => {
                      const element = document.getElementById(link.toLowerCase());
                      if (element) {
                        element.scrollIntoView({ behavior: 'smooth' });
                      }
                    }}
                    className="block text-sm text-gray-300 hover:text-white transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {link}
                  </button>
                ))}
              </div>
            </div>
            
            <div className="space-y-4">
              <h3 className="text-xs uppercase tracking-wider text-gray-400 mb-6">
                Contact Info
              </h3>
              <div className="space-y-3 text-sm text-gray-300">
                <div className="flex items-start gap-2">
                  <i className="ri-map-pin-line w-5 h-5 flex items-center justify-center mt-0.5"></i>
                  <div>
                    <p className="font-medium text-white">Address</p>
                    <p>Carlos M. Alvear 500</p>
                  </div>
                </div>
                
                <div className="flex items-start gap-2">
                  <i className="ri-building-line w-5 h-5 flex items-center justify-center mt-0.5"></i>
                  <div>
                    <p className="font-medium text-white">City</p>
                    <p>Palpala</p>
                  </div>
                </div>
                
                <div className="flex items-start gap-2">
                  <i className="ri-mail-line w-5 h-5 flex items-center justify-center mt-0.5"></i>
                  <div>
                    <p className="font-medium text-white">Zip</p>
                    <p>Y4613DWJ</p>
                  </div>
                </div>
                
                <div className="flex items-start gap-2">
                  <i className="ri-global-line w-5 h-5 flex items-center justify-center mt-0.5"></i>
                  <div>
                    <p className="font-medium text-white">Country</p>
                    <p>Argentina</p>
                  </div>
                </div>
                
                <div className="flex items-start gap-2">
                  <i className="ri-mail-send-line w-5 h-5 flex items-center justify-center mt-0.5"></i>
                  <div>
                    <p className="font-medium text-white">Email</p>
                    <a href="mailto:help@flamasrl.com" className="hover:text-white transition-colors">
                      help@flamasrl.com
                    </a>
                  </div>
                </div>
                
                <div className="flex items-start gap-2">
                  <i className="ri-phone-line w-5 h-5 flex items-center justify-center mt-0.5"></i>
                  <div>
                    <p className="font-medium text-white">Number</p>
                    <a href="tel:+18504683572" className="hover:text-white transition-colors">
                      +1 8504683572
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <div className="border-t border-gray-700 pt-12">
            <div className="text-center">
              <h2 className="text-7xl lg:text-8xl font-bold text-amber-100/20 tracking-tight">
                FLAMA
              </h2>
            </div>
          </div>
          
          <div className="mt-12 pt-8 border-t border-gray-700 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-400">
            <p>&copy; 2025 FLAMA S.R.L. All rights reserved.</p>
            <a 
              href="https://readdy.ai/?ref=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="hover:text-white transition-colors whitespace-nowrap cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
